// ============================================================
// VCS.CallControls — Call-/PreJoin-/Waiting-UI-Steuerung
// ============================================================
window.VCS = window.VCS || {};

VCS.CallControls = class {

    // ── Konstanten ───────────────────────────────────────────

    static AUDIO_MODE_KEY = 'audio-mode';
    static AUDIO_MODE_USER_SET_KEY = 'audio-mode-user-set';
    static NETWORK_QUALITY_KEY = 'network-quality';

    // ── Konstruktor ──────────────────────────────────────────

    constructor() {
        // View-Cache
        this._view = {
            // Call-Screen
            btnMute          : $('#btnMute'),
            btnCam           : $('#btnCam'),
            btnBlur          : $('#btnBlur'),
            blurPopup        : $('#blurPopup'),
            btnSpeaker       : $('#btnSpeaker'),
            btnCaptionOnly   : $('#btnCaptionOnly'),
            btnHangup        : $('#btnHangup'),
            btnCaptionRecord : $('#btnCaptionRecord'),
            remoteName       : $('#remoteName'),
            localVideoWrapper: $('#localVideoWrapper'),
            localCamOff      : $('#localCamOff'),
            remoteVideo      : $('#remoteVideo'),

            // Pre-Join
            preToggleMic                     : $('#preToggleMic'),
            preToggleCam                     : $('#preToggleCam'),
            btnOpenDeviceSettings            : $('#btnOpenDeviceSettings'),
            btnCloseDeviceSettings           : $('#btnCloseDeviceSettings'),
            deviceSettingsOverlay            : $('#deviceSettingsOverlay'),
            audioModeSelect                  : $('#audioModeSelect'),
            networkQualitySelect             : $('#networkQualitySelect'),
            camSelect                        : $('#camSelect'),
            micSelect                        : $('#micSelect'),
            btnOpenDeviceSettingsFromSettings: $('#btnOpenDeviceSettingsFromSettings'),

            // Waiting-Screen
            btnRingToggle  : $('#btnRingToggle'),
            waitingLeave   : $('#waitingLeave'),
            btnApprove     : $('#btnApprove'),
            btnDeny        : $('#btnDeny'),
            approvalOverlay: $('#approvalOverlay'),

            // Denied-Overlay
            btnBackToPreJoin: $('#btnBackToPreJoin'),
            deniedOverlay   : $('#deniedOverlay'),

            // Local-Video Drag
            localVideoWrapperDrag: $('#localVideoWrapper'),
        };
    }

    // ── Öffentliche Methoden ─────────────────────────────────

    updateMuteButton() {
        const s = VCS.state;
        VCS.ui?.setButtonIcon('btnMute', s.audioMuted ? 'micOff' : 'mic');
        this._view.btnMute.toggleClass('btn-active-red', s.audioMuted);
    }

    updateCamButton() {
        const s = VCS.state;
        VCS.ui?.setButtonIcon('btnCam', s.videoOff ? 'camOff' : 'cam');
        this._view.btnCam.toggleClass('btn-active-red', s.videoOff);
        this._view.localVideoWrapper.toggleClass('hidden', s.videoOff);
        this._view.localCamOff.toggleClass('hidden', !s.videoOff);
    }

    updateApprovalCallType() {
        const el = $('#approvalCallType')[0];
        if (!el) {
            return;
        }
        el.textContent = VCS.state.pendingGuestCamOff ? t('phoneCall') : t('videoCall');
    }

    // ── Init ─────────────────────────────────────────────────

    init() {
        this._setupCallControls();
        this._setupPreJoinControls();
        this._setupWaitingControls();
        this._setupDeniedOverlay();
        this._setupLocalVideoDrag();
    }

    // ── Private: Call-Controls ───────────────────────────────

    _setupCallControls() {
        const s = VCS.state;
        VCS.ui?.setButtonIcon('btnSpeaker', s.speakerOff ? 'speakerOff' : 'speaker');

        // Mic Toggle
        this._view.btnMute.on('click', () => {
            s.audioMuted = !s.audioMuted;
            s.baseStream?.getAudioTracks().forEach(t => t.enabled = !s.audioMuted);
            s.localStream?.getAudioTracks().forEach(t => t.enabled = !s.audioMuted);
            this.updateMuteButton();
            if (s.groupCallActive) {
                // SFU: Producer pause/resume
                if (s._sfuClient) {
                    if (s.audioMuted) s._sfuClient.pauseProducer('audio');
                    else s._sfuClient.resumeProducer('audio');
                }
                VCS.signaling?.send({
                                        type : 'group-mute',
                                        from : s.myId,
                                        muted: s.audioMuted
                                    });
                VCS.webrtc?.renderGroupGrid();
            } else {
                VCS.signaling?.send({
                                        type : 'mute',
                                        id   : s.myId,
                                        muted: s.audioMuted
                                    });
            }
        });

        // Cam Toggle
        this._view.btnCam.on('click', async () => {
            s.videoOff = !s.videoOff;
            if (s.videoOff) {
                s.camOffByButton = true;
                VCS.media?.scheduleCamHardStop();
            } else {
                s.camOffByButton = false;
                VCS.media?._clearCamHardStopTimer();
                const ok = await VCS.media?.ensureCameraTrackForEnable();
                if (!ok) {
                    s.videoOff = true;
                    s.camOffByButton = true;
                    VCS.media?.scheduleCamHardStop();
                }
            }
            s.baseStream?.getVideoTracks().forEach(t => t.enabled = !s.videoOff);
            s.localStream?.getVideoTracks().forEach(t => t.enabled = !s.videoOff);
            this.updateCamButton();
            if (s.groupCallActive) {
                // SFU: Producer pause/resume
                if (s._sfuClient) {
                    if (s.videoOff) s._sfuClient.pauseProducer('video');
                    else s._sfuClient.resumeProducer('video');
                }
                VCS.signaling?.send({
                                        type  : 'group-cam',
                                        from  : s.myId,
                                        camOff: s.videoOff
                                    });
                VCS.webrtc?.renderGroupGrid();
            } else {
                VCS.signaling?.send({
                                        type  : 'cam',
                                        id    : s.myId,
                                        camOff: s.videoOff
                                    });
            }
        });

        // Blur Toggle / Popup
        this._view.btnBlur.on('click', (e) => {
            e.stopPropagation();
            if (!s.blurEnabled) {
                s.blurEnabled = true;
                localStorage.setItem('blur-enabled', '1');
                VCS.ui?.updateBlurButtonUI();
                VCS.blur?.rebuild().catch(() => {
                });
                this._showBlurPopup();
            } else if (!this._view.blurPopup.hasClass('hidden')) {
                // Popup offen → schließen (Blur bleibt an)
                this._hideBlurPopup();
            } else {
                // Blur aus
                s.blurEnabled = false;
                localStorage.setItem('blur-enabled', '0');
                VCS.ui?.updateBlurButtonUI();
                VCS.blur?.rebuild().catch(() => {
                });
            }
        });

        // Blur-Stufe wählen
        this._view.blurPopup.on('click', '.blur-popup-btn', (e) => {
            e.stopPropagation();
            const px = parseInt(e.currentTarget.dataset.blur, 10);
            if (!px) {
                return;
            }
            VCS.Blur.BLUR_PX = px;
            localStorage.setItem('blur-px', px);
            this._updateBlurPopupActive(px);
        });

        // Popup schließen bei Klick außerhalb
        $(document).on('click', () => {
            this._hideBlurPopup();
        });

        // Lautsprecher Toggle
        this._view.btnSpeaker.on('click', () => {
            s.speakerOff = !s.speakerOff;
            if (s.groupCallActive) {
                // Alle Remote-Videos im Grid muten/unmuten
                document.querySelectorAll('.group-video-tile:not(.group-video-tile--self) video').forEach(v => v.muted = s.speakerOff);
            } else {
                const remoteVid = this._view.remoteVideo[0];
                if (remoteVid) {
                    remoteVid.muted = s.speakerOff;
                }
            }
            // Audio-Fader: Web-Audio-Pfad mit-mute (Original + uebersetzte
            // Stimme laufen ggf. ueber AudioContext, .muted am <video> reicht
            // dann nicht mehr -- siehe audio-fader.js onSpeakerToggle).
            VCS.audioFader?.onSpeakerToggle?.();
            VCS.ui?.setButtonIcon('btnSpeaker', s.speakerOff ? 'speakerOff' : 'speaker');
            this._view.btnSpeaker.toggleClass('btn-active-red', s.speakerOff);
        });

        // CC (Caption-Only) Toggle
        this._view.btnCaptionOnly.on('click', async () => {
            if (this._view.btnCaptionOnly.hasClass('call-cc-disabled')) {
                return;
            }
            // CC steuert nur die Anzeige. Die Mitschrift fuer die
            // Zusammenfassung laeuft unabhaengig davon (summary-capture).
            this.setCaptionOnly(!s.captionOnlyMode);
        });

        // Caption-Pause Toggle
        this._view.btnCaptionRecord.on('click', () => {
            VCS.captions?.togglePause().catch(() => {
            });
        });

        // Auflegen
        this._view.btnHangup.on('click', () => {
            this.resetSummary();
            if (s.groupCallActive) {
                VCS.webrtc?.endGroupCall(t('groupCallEnded'));
            } else {
                VCS.signaling?.send({
                                        type: 'leave',
                                        id  : s.myId
                                    });
                VCS.webrtc?.endCall(t('callEnded'));
            }
        });
    }

    // ── Gespraechszusammenfassung ──────────────────────

    // Gelber Punkt in der Namens-Pill, solange mitgeschrieben wird. Masse und
    // Rundung wie der Verbindungspunkt in der Status-Pill darunter -- die
    // beiden sollen gleich gross wirken.
    //
    // Wird auch aus webrtc.js gerufen: dort setzt .text(peerName) den Inhalt
    // der Pill komplett neu und wuerde den Punkt sonst wegwerfen.
    updateSummaryDot() {
        const $name = this._view.remoteName;
        if (!$name || !$name.length) {
            return;
        }
        $name.find('.call-summary-dot, .call-summary-peer').remove();
        if (VCS.state.callSummaryActive) {
            $name.append(`<span class="call-summary-dot" title="${t('callSummaryActive')}"></span>`);
        }
        // Das Gegenueber laesst zusammenfassen (27.09.): Dokument-Symbol statt
        // Punkt, damit es nicht mit der eigenen Bestellung verwechselt wird.
        // Antippen erklaert es -- title allein sieht man auf dem Handy nicht.
        if (VCS.state.callSummaryPeerActive) {
            const $peer = $(`<span class="call-summary-peer" role="button" tabindex="0" title="${t('callSummaryPeerActive')}">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5M9 13h6M9 17h4"/></svg>
            </span>`);
            $peer.on('click', (e) => {
                e.stopPropagation();
                VCS.ui?.showToast?.(t('callSummaryPeerActive'), 'info', 5000);
            });
            $name.append($peer);
        }
    }

    // Zustand vor jedem neuen Call zuruecksetzen. Wird aus beiden
    // Call-Einstiegen gerufen (waehlen und annehmen) und beim Auflegen.
    resetSummary() {
        const s = VCS.state;
        s.callSummaryWish         = false;
        s.callSummaryActive       = false;
        s.callSummaryPeerActive   = false;
        s.callSummaryPeerOrderers = [];
        s.summaryCapture          = false;
        this.updateSummaryDot();
    }

    // CC-Modus ein-/ausschalten. Der Server schaltet das Gegenueber ueber
    // caption-config mit (caption-only-activated).
    setCaptionOnly(on, toastKey) {
        const s = VCS.state;
        s.captionOnlyMode = !!on;
        this._view.btnCaptionOnly.toggleClass('btn-active-green', s.captionOnlyMode);
        VCS.captions?.sendConfig();
        if (s.captionOnlyMode) {
            s.captionsEnabled = true;
            VCS.captions?.startAutoCapture().catch(() => {
            });
            VCS.ui?.showToast?.(t(toastKey || 'captionOnlyOn'), 'success', toastKey ? 4000 : 1800);
        } else {
            // Laeuft die Mitschrift-Erkennung, endet nur die Anzeige.
            if (s.summaryCapture) {
                VCS.captions?.stopDisplayKeepCapture();
            } else {
                VCS.captions?.releasePipeline();
            }
            VCS.captions?.clearTranslated();
            VCS.captions?.clearSelfTranscript();
            VCS.ui?.showToast?.(t('captionOnlyOff'), 'info', 1800);
        }
        VCS.captions?.updateFabUI();
    }

    // ── Private: Pre-Join Controls ──────────────────────────

    _setupPreJoinControls() {
        const s = VCS.state;
        VCS.ui?._updatePreJoinToggleButtons();
        VCS.netStats?.updateVisibility();
        VCS.media?.updatePreviewCamOffName();

        // Mic Toggle (Vorschau)
        this._view.preToggleMic.on('click', () => {
            s.audioMuted = !s.audioMuted;
            s.baseStream?.getAudioTracks().forEach(t => t.enabled = !s.audioMuted);
            s.localStream?.getAudioTracks().forEach(t => t.enabled = !s.audioMuted);
            VCS.ui?._updatePreJoinToggleButtons();
        });

        // Cam Toggle (Vorschau)
        this._view.preToggleCam.on('click', async () => {
            s.videoOff = !s.videoOff;
            if (s.videoOff) {
                s.camOffByButton = true;
                VCS.media?.scheduleCamHardStop();
            } else {
                s.camOffByButton = false;
                VCS.media?._clearCamHardStopTimer();
                const ok = await VCS.media?.ensureCameraTrackForEnable();
                if (!ok) {
                    s.videoOff = true;
                    s.camOffByButton = true;
                    VCS.media?.scheduleCamHardStop();
                }
            }
            s.baseStream?.getVideoTracks().forEach(t => t.enabled = !s.videoOff);
            s.localStream?.getVideoTracks().forEach(t => t.enabled = !s.videoOff);
            VCS.ui?._updatePreJoinToggleButtons();
        });

        // Device-Settings Overlay öffnen/schließen
        const previewVideo = $('#devicePreviewVideo')[0];

        const openDeviceSettings = async (fromSettings) => {
            if (fromSettings) {
                // Kamera-Preview starten
                this._devicePreviewStream = null;
                try {
                    this._devicePreviewStream = await navigator.mediaDevices.getUserMedia({
                                                                                              audio: true,
                                                                                              video: true
                                                                                          });
                } catch (_) {
                    // Fallback: nur Audio (z.B. wenn Kamera blockiert)
                    try {
                        this._devicePreviewStream = await navigator.mediaDevices.getUserMedia({audio: true});
                    } catch (_) {
                    }
                }
                if (this._devicePreviewStream && previewVideo) {
                    previewVideo.srcObject = this._devicePreviewStream;
                    // iOS Safari: manueller play()-Aufruf nötig
                    previewVideo.play().catch(() => {
                    });
                }
                await VCS.media?._populateDevices?.();
            }
            this._view.deviceSettingsOverlay.removeClass('hidden');
        };

        const closeDeviceSettings = () => {
            this._view.deviceSettingsOverlay.addClass('hidden');
            // Preview stoppen wenn aus Settings geöffnet
            if (this._devicePreviewStream) {
                this._devicePreviewStream.getTracks().forEach(t => t.stop());
                this._devicePreviewStream = null;
                if (previewVideo) {
                    previewVideo.srcObject = null;
                }
            }
        };

        this._view.btnOpenDeviceSettings.on('click', () => openDeviceSettings(false));
        this._view.btnOpenDeviceSettingsFromSettings.on('click', () => openDeviceSettings(true));
        this._view.btnCloseDeviceSettings.on('click', closeDeviceSettings);
        this._view.deviceSettingsOverlay.on('click', (e) => {
            if (e.target === this._view.deviceSettingsOverlay[0]) {
                closeDeviceSettings();
            }
        });

        // Audio-Profil
        this._view.audioModeSelect.val(s.audioMode).on('change', async (e) => {
            s.audioMode = e.target.value;
            localStorage.setItem(VCS.CallControls.AUDIO_MODE_KEY, s.audioMode);
            localStorage.setItem(VCS.CallControls.AUDIO_MODE_USER_SET_KEY, '1');
            if (this._devicePreviewStream) {
                await refreshDevicePreview();
            } else {
                await VCS.media?.initPreview();
            }
        });

        // Netzwerkqualität
        this._view.networkQualitySelect.val(s.networkQuality).on('change', async (e) => {
            s.networkQuality = e.target.value;
            localStorage.setItem(VCS.CallControls.NETWORK_QUALITY_KEY, s.networkQuality);
            if (this._devicePreviewStream) {
                await refreshDevicePreview();
            } else {
                await VCS.media?.initPreview();
            }
        });

        // Gerätewechsel
        const refreshDevicePreview = async () => {
            if (!this._devicePreviewStream) {
                return false;
            }
            // Alten Preview-Stream stoppen — iOS Safari braucht das bevor ein neuer Stream geholt wird
            this._devicePreviewStream.getTracks().forEach(t => t.stop());
            this._devicePreviewStream = null;
            if (previewVideo) {
                previewVideo.srcObject = null;
            }
            // Neuen Stream mit gewählten Geräten
            // iOS Safari: "ideal" statt "exact" bei deviceId, da exact oft fehlschlägt
            const videoC = VCS.media?.getVideoConstraints?.() || true;
            const audioC = VCS.media?.getAudioConstraints?.() || true;
            if (videoC && typeof videoC === 'object' && videoC.deviceId?.exact) {
                videoC.deviceId = {ideal: videoC.deviceId.exact};
            }
            if (audioC && typeof audioC === 'object' && audioC.deviceId?.exact) {
                audioC.deviceId = {ideal: audioC.deviceId.exact};
            }
            const constraints = {
                audio: audioC,
                video: videoC
            };
            try {
                this._devicePreviewStream = await navigator.mediaDevices.getUserMedia(constraints);
                if (previewVideo) {
                    previewVideo.srcObject = this._devicePreviewStream;
                    previewVideo.play().catch(() => {
                    });
                }
                return true;
            } catch (err) {
                console.warn('[device-settings] Gerätewechsel fehlgeschlagen:', err);
                VCS.ui?.showToast?.(t('mediaError'), 'error');
                return false;
            }
        };

        this._view.camSelect.on('change', async (e) => {
            s.selectedCamId = e.target.value;
            if (this._devicePreviewStream) {
                const ok = await refreshDevicePreview();
                if (ok) {
                    localStorage.setItem('last-cam-id', s.selectedCamId);
                }
            } else {
                await VCS.media?.initPreview();
                if (s.baseStream && s.baseStream.getVideoTracks().length > 0) {
                    localStorage.setItem('last-cam-id', s.selectedCamId);
                }
            }
        });
        this._view.micSelect.on('change', async (e) => {
            s.selectedMicId = e.target.value;
            if (this._devicePreviewStream) {
                const ok = await refreshDevicePreview();
                if (ok) {
                    localStorage.setItem('last-mic-id', s.selectedMicId);
                }
            } else {
                await VCS.media?.initPreview();
                if (s.baseStream && s.baseStream.getAudioTracks().length > 0) {
                    localStorage.setItem('last-mic-id', s.selectedMicId);
                }
            }
        });
    }

    // ── Private: Waiting-Controls ───────────────────────────

    _setupWaitingControls() {
        const s = VCS.state;

        this._view.btnRingToggle.on('click', () => {
            s.ringEnabled = !s.ringEnabled;
            localStorage.setItem('ring-enabled', s.ringEnabled ? '1' : '0');
            if (!s.ringEnabled) {
                VCS.audioMonitor?.stopIncomingKnock();
            }
            VCS.audioMonitor?.updateRingToggleUI();
        });

        // Abbrechen
        this._view.waitingLeave.on('click', () => {
            VCS.audioMonitor?.stopIncomingKnock();
            s.activeJoinNotification?.close();
            s.activeJoinNotification = null;
            // Direct-Call Caller: Backend informieren damit Callee-Callkit / Dialog schliesst
            if (s.directCallActive && s.directCallPeerPhone && VCS.state.ROOM_ID) {
                fetch(VCS.Chat.API_BASE + '/call/direct/cancel', {
                    method : 'POST',
                    headers: VCS.chat?.authHeaders({'Content-Type': 'application/json'}),
                    body   : JSON.stringify({
                        callId     : VCS.state.ROOM_ID,
                        calleePhone: s.directCallPeerPhone,
                    }),
                }).catch(() => {});
            }
            VCS.signaling?.send({
                                    type: 'leave',
                                    id  : s.myId,
                                });
            s.myRole = null;
            VCS.session?.resetToPreJoin(true);
            s.pendingRegisterOnOpen = false;
            s.directCallActive = false;
            s.directCallPeerName = '';
            s.directCallPeerPhone = '';
            VCS.session?.setRejoinHint(false);
            VCS.nav?.showHomeScreen();
            if (s.ws) {
                s.ws.close();
            }
            VCS.signaling?.scheduleReconnect(500);
        });

        // Genehmigen
        this._view.btnApprove.on('click', () => {
            VCS.audioMonitor?.stopIncomingKnock();
            s.activeJoinNotification?.close();
            s.activeJoinNotification = null;
            if (s.pendingGuestId) {
                VCS.signaling?.send({
                                        type   : 'approve',
                                        id     : s.myId,
                                        guestId: s.pendingGuestId,
                                    });
            }
            this._view.approvalOverlay.addClass('hidden');
            s.pendingGuestId = null;
            s.pendingGuestCamOff = false;
            this.updateApprovalCallType();
        });

        // Ablehnen
        this._view.btnDeny.on('click', () => {
            VCS.audioMonitor?.stopIncomingKnock();
            s.activeJoinNotification?.close();
            s.activeJoinNotification = null;
            if (s.pendingGuestId) {
                VCS.signaling?.send({
                                        type   : 'deny',
                                        id     : s.myId,
                                        guestId: s.pendingGuestId,
                                    });
            }
            this._view.approvalOverlay.addClass('hidden');
            s.pendingGuestId = null;
            s.pendingGuestCamOff = false;
            this.updateApprovalCallType();
        });
    }

    // ── Private: Denied-Overlay ─────────────────────────────

    _setupDeniedOverlay() {
        this._view.btnBackToPreJoin.on('click', () => {
            this._view.deniedOverlay.addClass('hidden');
            VCS.nav?.showHomeScreen();
            VCS.session?.resetToPreJoin(true);
            VCS.state.pendingRegisterOnOpen = false;
            VCS.session?.setRejoinHint(false);
            if (VCS.state.ws) {
                VCS.state.ws.close();
            }
            VCS.signaling?.scheduleReconnect(500);
        });
    }

    // ── Private: Local-Video Drag ───────────────────────────

    _setupLocalVideoDrag() {
        const el = this._view.localVideoWrapperDrag[0];
        if (!el) {
            return;
        }
        let dragging = false;
        let offsetX = 0, offsetY = 0;

        function startDrag(clientX, clientY) {
            dragging = true;
            const rect = el.getBoundingClientRect();
            offsetX = clientX - rect.left;
            offsetY = clientY - rect.top;
            el.style.left = rect.left + 'px';
            el.style.top = rect.top + 'px';
            el.style.right = 'auto';
            el.style.bottom = 'auto';
            el.style.transition = 'none';
        }

        function moveDrag(clientX, clientY) {
            if (!dragging) {
                return;
            }
            const parent = el.parentElement.getBoundingClientRect();
            let x = clientX - offsetX - parent.left;
            let y = clientY - offsetY - parent.top;
            x = Math.max(0, Math.min(x, parent.width - el.offsetWidth));
            y = Math.max(0, Math.min(y, parent.height - el.offsetHeight));
            el.style.left = x + 'px';
            el.style.top = y + 'px';
        }

        function endDrag() {
            dragging = false;
            el.style.transition = '';
        }

        // Touch-Events
        el.addEventListener('touchstart', (e) => {
            const touch = e.touches[0];
            startDrag(touch.clientX, touch.clientY);
        }, {passive: true});

        el.addEventListener('touchmove', (e) => {
            e.preventDefault();
            const touch = e.touches[0];
            moveDrag(touch.clientX, touch.clientY);
        }, {passive: false});

        el.addEventListener('touchend', endDrag);

        // Maus-Events (Desktop-Test)
        el.addEventListener('mousedown', (e) => {
            startDrag(e.clientX, e.clientY);
            e.preventDefault();
        });

        document.addEventListener('mousemove', (e) => {
            moveDrag(e.clientX, e.clientY);
        });

        document.addEventListener('mouseup', endDrag);
    }

    // ── Blur-Popup ──────────────────────────────────────────

    _showBlurPopup() {
        const savedPx = parseInt(localStorage.getItem('blur-px'), 10) || 20;
        VCS.Blur.BLUR_PX = savedPx;
        this._updateBlurPopupActive(savedPx);
        this._view.blurPopup.removeClass('hidden');
    }

    _hideBlurPopup() {
        this._view.blurPopup.addClass('hidden');
    }

    _updateBlurPopupActive(px) {
        this._view.blurPopup.find('.blur-popup-btn').each(function () {
            const val = parseInt(this.dataset.blur, 10);
            $(this).toggleClass('blur-popup-btn--active', val === px);
        });
    }
};
